module.exports = "https://static.wmbcdn.com/uniweb/images/8e4486147db7bcd15e595452f6cbd6d1.png";